import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useGetRoomLabels } from 'components/Offer/hooks/useGetRoomLabels';
import { getAppLockedDealConfig, getOfferHasGhaOrGvrPreferredRate } from 'modules/sapiSearch/selectors';
import { Hotel, SearchOffer } from 'modules/sapiSearch/slice';
import { getIsLockedDealExcludingGHA, getShouldShowYourChoiceTag } from 'modules/search/selectors';
import { toggle } from 'opticks';
import { equals, last } from 'ramda';
import { Text } from '@daedalus/atlas/Text';
export interface Props {
  /** Whether to render the labels in the alternative color  */
  isAlternativeColor?: boolean;
  /** Offer state */
  offer: SearchOffer;
  hotelId: Hotel['objectID'];
  isRequiredOneTimePasswordFlow?: boolean;
}
const _exp = /*#__PURE__*/() => Text;
const RoomLabelsText = /*#__PURE__*/styled(_exp())({
  name: "RoomLabelsText",
  class: "r84dz6i",
  propsAsIs: true
});
const RoomLabelsItem = /*#__PURE__*/styled('span')({
  name: "RoomLabelsItem",
  class: "rzgy81h",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => RoomLabelsText;
const Dot = /*#__PURE__*/styled(_exp7())({
  name: "Dot",
  class: "d4bix8i",
  propsAsIs: true
});
export const RoomLabels = ({
  offer,
  isAlternativeColor = false,
  hotelId,
  isRequiredOneTimePasswordFlow = false
}: Props) => {
  const {
    isAppLockedDeal
  } = useSelector(state => getAppLockedDealConfig(state, hotelId, offer?.id));
  const offerHasGhaOrGvrPreferredRate = useSelector(state => getOfferHasGhaOrGvrPreferredRate(state, offer));
  const isLockedDeal = useSelector(getIsLockedDealExcludingGHA(offer));
  const shouldShowYourChoice = useSelector(getShouldShowYourChoiceTag(offer));
  const shouldShowFreeCancellationDate = offerHasGhaOrGvrPreferredRate && toggle('feature-free-cancellation-date-gha-gvr-preferred-rate-offers', isLockedDeal || isAppLockedDeal || isRequiredOneTimePasswordFlow, true);
  const translatedLabels = useGetRoomLabels({
    offer,
    shouldShowFreeCancellationDate
  });
  if (translatedLabels.length <= 0) return null;
  return <RoomLabelsText dataId="RoomLabels" className={cx('container-rooms-label', isAlternativeColor && '__isAlternativeColor', shouldShowYourChoice && '__hasFirstGreen')}>
      {translatedLabels.map(label => <RoomLabelsItem key={label}>
          {label}
          {!equals(last(translatedLabels), label) && <Dot as="span" className={cx(isAlternativeColor && '__isAlternativeColor')}>
              ·
            </Dot>}
        </RoomLabelsItem>)}
    </RoomLabelsText>;
};

require("./RoomLabels.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomLabels.tsx");